import { useMemo } from 'react'
import { TooltipWrapper } from '@winnin/winnin_ui.components.tooltip-wrapper'

import { useTranslate } from 'lib/tolgee'
import { TOLGEE_GLOBALS } from 'utils'
import { jobUtils } from 'utils/jobUtils'

const TOLGEE_PREFIX = 'JobPinsLimitStatus'

/**
 * @param {Object} props
 * @param {import("utils/jobUtils").JobWithPins} props.job
 * @param {import("utils/planUtils").Plan} props.plan
 */
export default function JobPinsLimitStatus({ job, plan }) {
  const t = useTranslate()

  const content = useMemo(() => {
    const isFull = jobUtils.isFull(job, plan)
    const isAlmostFull = jobUtils.isAlmostFull(job, plan)

    if (isFull) {
      return {
        label: t(TOLGEE_GLOBALS.full),
        tooltipMessage: t({
          key: `${TOLGEE_PREFIX}-full-asDashboard`,
          parameters: {
            total: job.pins.totalAmount,
            limit: plan.jobPins,
          },
          defaultValue:
            'Você possui {total} de {limit} referências salvas. Para adicionar novas referências, edite ou crie um novo dashboard.',
        }),
      }
    }

    if (isAlmostFull) {
      return {
        label: t(TOLGEE_GLOBALS.almostFull),
        tooltipMessage: t({
          key: `${TOLGEE_PREFIX}-almostFull`,
          parameters: {
            total: job.pins.totalAmount,
            limit: plan.jobPins,
          },
          defaultValue: 'Você possui {total} de {limit} referências salvas.',
        }),
      }
    }
  }, [job, plan, t])

  if (!content) {
    return null
  }

  return (
    <TooltipWrapper className="JobPinsLimitStatus" tooltipStyle="tooltippedS" tooltipMessage={content.tooltipMessage}>
      {content.label}
    </TooltipWrapper>
  )
}
